export class JSONHelper {
    static getDataByKey(obj, key) {
        if (key in obj) { 
            return obj[key];
        }
        const keys = key.split("."); 
        let value = obj;
        for (let key of keys) {
            value = value[key];
            if (value === undefined) {
                break;
            }
        }       
        return value;
    } 
    
    static creteObjectClone(object: any){
        return JSON.parse(JSON.stringify(object));
    }

    static mapToJson<K, V>(data: Map<K, V>){
        return JSON.stringify(data, (key, value) =>
            value instanceof Map ? Array.from(value.entries()) : value
        );
    }

    static objToMap(mapString: string){
        let map = new Map();
        let obj = JSON.parse(mapString);
        obj.forEach((value, key) => {
            map.set(value[0], value[1]);
        });
        return map;
    }

    static mapToJsonObj(data: Map<string, string>){
        let objString = "{ ";
        data.forEach((value, key) => {
            objString = objString.concat('"', key, '" : "', value, '",');
        });
        objString = objString.substring(0, objString.length - 1).concat(" }");
        return JSON.parse(objString);
    }
}